<script>
/**
 * 受注紐付けモーダル
 */
import { mapActions } from "vuex";
import InfiniteEmissionAndLocationAutoComplete from "@/driver/components/InfiniteEmissionAndLocationAutoComplete.vue";
import InfiniteTraderAutoComplete from "@/driver/components/InfiniteTraderAutoComplete.vue";
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import _ from "lodash";


export default {
  name: "AssociationOrderModal",
  components: {
    CustomPagination,
    InfiniteEmissionAndLocationAutoComplete,
    InfiniteTraderAutoComplete,
  },
  props: {
    enableDialog: {
      type: Boolean,
      default: false,
    },
    targetDate: {
      type: String,
      default: null,
    },
    targetDriverId: {
      type: Number,
      default: null,
    },
    targetDriverName: {
      type: String,
      default: null,
    },
    drivers: {
      type: Array,
    },
  },
  data() {
    return {
      searchPanel: 0,
      page: 1,
      perPage: 50,
      totalVisible: 7,
      selectedButton: null,
      disableActions: false,
      checkedResults: [],
      pagination: {
        current_page: 1,
        total_count: 0,
      },

      searchForms: {
        /** 排出事業者ID */
        emissionId: null,
        /** 排出事業場ID */
        emissionLocationId: null,
        /** 排出事業場コード */
        emissionLocationCode: null,
        /** 処分事業場ID */
        disposerId: null,
        /** キーワード */
        keyword: null,
        /** ドライバーID */
        driverId: null,
        /** ドライバー名 */
        driverName: null,
        /** 車両番号 */
        vehicleNumber: null,
        /** 配車済みも表示  */
        withAssigned: false,
        /** 受注番号 */
        orderNumber: null,
        /** 引取搬入番号 */
        requestNumber: null,
        /** 回収日未定のみを表示 */
        withUndecidedPlanDate: false,
      },
      /* 受注データ補完 */
      tableHeaders: [
        { text: "受注番号\r\n引取搬入番号", value: "order_no" },
        { text: "運搬担当者\r\n受注日", value: "driver" },
        { text: "回収・引取\r\n・搬入日", value: "target_date" },
        { text: "取引先 (事業者)\r\n取引先 (事業場)", value: "supplier" },
        { text: "運送先事業場", value: "destination_location" },
        { text: "取扱品目\r\n荷姿", value: "item" },
        { text: "マニフェスト", value: "manifest" },
      ],
      orders: [],

      emissionPageNumber: 0,
      emissions: [],
      emissionSearchKeyword: null,
      loadingEmissions: false,
      emissionPagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },

      emissionLocationPageNumber: 0,
      emissionLocations: [],
      emissionLocationSearchKeyword: null,
      loadingEmissionLocations: false,
      emissionLocationPagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },

      disposerPageNumber: 0,
      disposers: [],
      disposerSearchKeyword: null,
      loadingDisposers: false,
      disposerPagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },

      vehicles: [],
    };
  },
  computed: {},
  watch: {
    /**
     * モーダル表示フラグの監視
     * @param value
     */
    enableDialog(value) {
      this.searchPanel = 0;
      this.checkedResults = [];
      this.orders = [];
      this.driver = null;
      this.perPage = 15;
      this.pagination = { current_page: 1, total_count: 0 };
      Object.assign(this.$data.searchForms, this.$options.data().searchForms);

      if (value) {
        this.searchEmissions();
        this.searchEmissionLocations();
        this.fetchVehicles({ registered_number: true }).then((content) => {
          this.vehicles = content.vehicles;
        });
      }
    },
  },
  methods: {
    ...mapActions("DriverScheduleAssociationOrder", {
      fetchOrders: "index",
      assignToDriver: "create",
    }),
    ...mapActions("DriverMasterSearchTraderMember", {
      fetchDisposers: "index",
    }),
    ...mapActions("DriverMasterSearchEmission", {
      fetchEmissions: "index",
    }),
    ...mapActions("DriverMasterSearchEmissionWorkplace", {
      fetchEmissionLocations: "index",
    }),
    ...mapActions("DriverMasterSearchVehicle", {
      fetchVehicles: "search",
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent() {
      this.$emit("closeCallback");
    },
    /**
     * 行選択時のトグル処理
     */
    toggleRowSelection(item) {
      if (!item.disabled) {
        const index = this.checkedResults.findIndex((row) => row === item);
        if (index > -1) {
          this.checkedResults.splice(index, 1);
        } else {
          this.checkedResults.push(item);
        }
      }
    },
    /**
     * チェックボックスの一括切替 クリックイベント
     */
    selectedAllCheckboxClickEvent({ value, items }) {
      if (value) {
        this.checkedResults = items.filter((item) => !item.disabled);
      } else {
        this.checkedResults = [];
      }
    },
    /**
     * ドライバー紐付けボタン クリックイベント
     */
    registerButtonClickEvent() {
      //　選択された受注のIDを抜き出す
      const ids = this.checkedResults.map((item) => item.id);

      let params = {
        driver_id: this.targetDriverId,
        target_date: this.targetDate,
        order_ids: ids,
        association_order: { transport_user_id: this.targetDriverId },
      };
      this.assignToDriver({ params: params }).then(() => {
        this.$emit("registerCallback");
      });
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1;
      this.searchAssigns();
    },
    /**
     * 検索処理の実行
     */
    searchAssigns() {
      const params = {
        emission_id: this.searchForms.emissionId,
        emission_location_id: this.searchForms.emissionLocationId,
        disposer_id: this.searchForms.disposerId,
        keyword: this.searchForms.keyword,
        driver_id: this.searchForms.driverId,
        driver_name: this.searchForms.driverName,
        vehicle_number: this.searchForms.vehicleNumber,
        with_assigned: this.searchForms.withAssigned,
        order_number: this.searchForms.orderNumber,
        request_number: this.searchForms.requestNumber,
        with_undecided_plan_date: this.searchForms.withUndecidedPlanDate,
        target_date: this.targetDate,
        target_driver_id: this.targetDriverId,
        page: this.page,
        limit: this.perPage,
      };
      this.disableActions = true;
      this.orders = [];
      /**
       * @typedef content { Object }
       * @property assigns { Array }
       */
      this.fetchOrders({ conditions: params }).then((content) => {
        this.orders = content.association_order;
        this.pagination = content.pagination;
        this.disableActions = false;
      });
    },
    /**
     * ページチェンジ イベント
     * @param page
     */
    pageChangeEvent(page) {
      this.page = page;
      this.searchAssigns();
    },
    /**
     * 一覧表示件数 チェンジイベント
     * @param perPage
     */
    perPageChangeCallback(perPage) {
      this.perPage = perPage;
      this.page = 1;
      this.searchAssigns();
    },
    /**
     * ドライバーチェンジイベント
     */
    driverChangeEvent(driver_id) {
      const driver = this.drivers.find((v) => v.value === driver_id);
      if (driver) {
        this.searchForms.driverName = driver.text;
      }
      this.searchButtonClickEvent();
    },
    /**
     * ドライバークリアイベント
     */
    driverClearEvent() {
      this.searchForms.driverId = null;
      this.searchForms.driverName = null;
    },
    /**
     * 排出事業者・排出事業場チェンジコールバック
     * @param emission_id { Number } 排出事業者ID
     * @param location_id { Number } 排出事業場ID
     * @param location_code { String } 排出事業場コード
     */
    emissionChangeCallback(emission_id, location_id, location_code) {
      let changed = false;
      if (this.searchForms.emissionId !== emission_id) {
        changed = true;
      }
      if (this.searchForms.emissionLocationId !== location_id) {
        changed = true;
      }

      this.searchForms.emissionId = emission_id;
      this.searchForms.emissionLocationId = location_id;
      this.searchForms.emissionLocationCode = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 処分業者チェンジ コールバック
     */
    disposerChangedCallback (disposer_id) {

      let changed = false;

      if (this.searchForms.disposerId !== disposer_id) {
        changed = true;
      }
      this.searchForms.disposerId = disposer_id;

      if (changed) {
        this.handleSearch();
      }
    },
    /**
     * 検索処理を実行する
     */
    handleSearch () {
      if (!this.stopSearch) {
        this.searchButtonClickEvent();
      }
    },

    /**
     * 排出事業者の検索処理
     */
    searchEmissions() {
      // ロードを開始
      this.loadingEmissions = true;

      // 検索条件を設定
      const conditions = {
        query: this.emissionSearchKeyword,
        location_id: this.searchForms.emissionLocationId,
      };

      this.fetchEmissions({ query: conditions, page: this.emissionPageNumber })
        .then((response) => {
          // 検索結果を追加
          this.emissions = this.emissions.concat(response.emissions);

          // 排出事業場が決定しており、排出事業者のリスト件数が1件の場合は選択状態にする
          if (
            this.searchForms.emissionLocationId &&
            this.emissions.length === 1
          ) {
            this.searchForms.emissionId = this.emissions[0].value;
          }
          this.emissionPagination = response.pagination;
          this.emissionPageNumber = response.pagination.current_page;
        })
        .finally(() => {
          this.loadingEmissions = false;
        });
    },
    /**
     * 排出事業場の検索処理
     */
    searchEmissionLocations() {
      this.loadingEmissionLocations = true;

      const conditions = {
        query: this.emissionLocationSearchKeyword,
        emission_id: this.searchForms.emissionId,
      };

      this.fetchEmissionLocations({
        query: conditions,
        page: this.emissionLocationPageNumber,
      })
        .then((response) => {
          this.emissionLocations = this.emissionLocations.concat(
            response.emission_locations
          );

          // 排出事業者が決定しており、排出事業場のリスト件数が1件の場合は選択状態にする
          if (
            this.searchForms.emissionId &&
            this.emissionLocations.length === 1
          ) {
            this.searchForms.emissionLocationId =
              this.emissionLocations[0].value;
          }

          this.emissionLocationPagination = response.pagination;
          this.emissionLocationPageNumber = response.pagination.current_page;
        })
        .finally(() => {
          this.loadingEmissionLocations = false;
        });
    },
    /**
     * 処分事業者の検索処理
     */
    searchDisposers() {
      this.loadingEmissionLocations = true;
      const conditions = {
        name: this.disposerSearchKeyword,
        search_type: "trader",
        page: this.disposerPageNumber,
      };
      this.fetchDisposers({ params: conditions })
        .then((response) => {
          this.disposers = this.disposers.concat(response.traders);
          this.disposerPagination = response.pagination;
          this.disposerPageNumber = response.pagination.current_page;
        })
        .finally(() => {
          this.loadingEmissionLocations = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <v-dialog
      :value="enableDialog"
      width="1500"
      scrollable
      @click:outside="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title
            >{{ targetDriverName }}に{{
              targetDate | date_format
            }}の受注を紐付ける</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text class="mt-3">
          <!-- 検索ブロック -->
          <v-row>
            <v-col>
              <v-expansion-panels v-model="searchPanel" accordion>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    class="panel-header-color panel-selectable"
                  >
                    <strong>
                      <v-icon class="panel-header-color"> mdi-magnify </v-icon>
                      &nbsp;条件を指定して検索
                    </strong>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text>
                        <v-row>
                          <!-- 排出事業者／排出事業場 -->
                          <v-col>
                            <infinite-emission-and-location-auto-complete
                              :supplier-id="searchForms.emissionId"
                              :location-id="searchForms.emissionLocationId"
                              :location-code="searchForms.emissionLocationCode"
                              :without-general-form="false"
                              :uncontrol-disabled="true"
                              classes="search-font"
                              supplier-md="6"
                              location-md="6"
                              supplier-label="排出事業者"
                              location-label="排出事業場"
                              rounded
                              @update:values="emissionChangeCallback"
                            />
                          </v-col>
                          <!-- /排出事業者／排出事業場 -->
                        </v-row>

                        <v-row>
                          <!-- 処分業者／処分場 -->
                          <v-col cols="12" md="6">
                            <infinite-trader-auto-complete
                              :trader-id="searchForms.disposerId"
                              classes="search-font"
                              search-type="trader"
                              rounded
                              label="処分業者・処分場"
                              @update:values="disposerChangedCallback"
                            />
                          </v-col>
                          <!-- /処分業者／処分場 -->

                          <!-- キーワード -->
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="searchForms.keyword"
                              clearable
                              dense
                              hide-details="auto"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              label="キーワード検索"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent()"
                              @click:clear="
                                searchForms.keyword = null;
                                searchButtonClickEvent();
                              "
                            />
                          </v-col>
                          <!-- /キーワード -->
                        </v-row>

                        <v-row>
                          <!-- 運搬担当者 -->
                          <v-col cols="12" md="3">
                            <v-autocomplete
                              v-model="searchForms.driverId"
                              :items="drivers"
                              clearable
                              dense
                              hide-details="auto"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              label="運搬担当者"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @change="driverChangeEvent"
                              @click:clear="driverClearEvent"
                            />
                          </v-col>
                          <!-- /運搬担当者 -->

                          <!-- 車両番号 -->
                          <v-col cols="12" md="3">
                            <v-autocomplete
                              v-model="searchForms.vehicleNumber"
                              :items="vehicles"
                              clearable
                              dense
                              hide-details="auto"
                              item-text="number"
                              item-value="number"
                              :return-object="false"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              label="車両番号"
                              rounded
                              style="font-size: 80%"
                              @change="searchButtonClickEvent()"
                              @click:clear="
                                searchForms.vehicleNumber = null;
                                searchButtonClickEvent();
                              "
                            />
                          </v-col>
                          <!-- /車両番号 -->

                          <!-- ドライバー割り当て済みも表示する (searchWithAssign)-->
                          <v-col cols="12" md="3">
                            <v-checkbox
                              v-model="searchForms.withAssigned"
                              class="mt-2"
                              label="ドライバー割り当て済みも表示する"
                              dense
                              hide-details="auto"
                              @change="searchButtonClickEvent()"
                            />
                          </v-col>
                          <!-- /ドライバー割り当て済みも表示する -->
                        </v-row>

                        <v-row>
                          <!-- 受注番号 -->
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForms.orderNumber"
                              clearable
                              dense
                              hide-details="auto"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              label="受注番号"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent()"
                              @click:clear="
                                searchForms.orderNumber = null;
                                searchButtonClickEvent();
                              "
                            />
                          </v-col>
                          <!-- /受注番号 -->

                          <!-- 引取搬入番号 -->
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForms.requestNumber"
                              clearable
                              dense
                              hide-details="auto"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              label="引取搬入番号"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent()"
                              @click:clear="
                                searchForms.requestNumber = null;
                                searchButtonClickEvent();
                              "
                            />
                          </v-col>
                          <!-- /引取搬入番号 -->

                          <!-- 回収日未定のみを表示 -->
                          <v-col cols="12" md="3">
                            <v-checkbox
                              v-model="searchForms.withUndecidedPlanDate"
                              class="mt-2"
                              label="回収日未定のみを表示"
                              dense
                              hide-details="auto"
                              @change="searchButtonClickEvent()"
                            />
                          </v-col>
                          <!-- /回収日未定のみを表示 -->
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="primary"
                          @click="searchButtonClickEvent()"
                        >
                          <v-icon> mdi-magnify </v-icon>
                          &nbsp;検索
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <!-- /検索ブロック -->

          <!-- ページング -->
          <v-row>
            <v-col>
              <custom-pagination
                :page-number="page"
                :per-page="perPage"
                :pagination="pagination"
                :total-visible="totalVisible"
                @pageChanged="pageChangeEvent"
                @perPageChanged="perPageChangeCallback"
              />
            </v-col>
          </v-row>
          <!-- /ページング -->

          <!-- ドライバー受注紐付け一覧 -->
          <v-row>
            <v-col cols="12">
              <v-data-table
                v-model="checkedResults"
                :headers="tableHeaders"
                :items="orders"
                :items-per-page="-1"
                hide-default-footer
                disable-sort
                show-select
                @click:row="toggleRowSelection"
                @toggle-select-all="selectedAllCheckboxClickEvent($event)"
              >
                <template
                  v-slot:[`item.data-table-select`]="{
                    item,
                    isSelected,
                    select,
                  }"
                >
                  <v-simple-checkbox
                    :value="isSelected"
                    :readonly="item.disabled"
                    :disabled="item.disabled"
                    :indeterminate="item.disabled"
                    @input="select($event)"
                  />
                </template>
                <!-- 受注番号/引取搬入番号 -->
                <template v-slot:[`item.order_no`]="{ item }">
                  <div>
                    <span>{{ item.order_no || "-" }}</span>
                  </div>
                  <div>
                    <span>{{ item.request_no || "-" }}</span>
                  </div>
                </template>
                <!-- /受注番号/引取搬入番号 -->

                <!-- ドライバー -->
                <template v-slot:[`item.driver`]="{ item }">
                  <div>
                    <span v-if="item.driver">
                      {{ item.driver.name }}
                    </span>
                    <span v-else> - </span>
                  </div>
                  <small class="text--disabled">
                    {{ item.order_date | date_format }}
                  </small>
                </template>
                <!-- /ドライバー -->

                <!-- 回収・積替・搬入日 -->
                <template v-slot:[`item.target_date`]="{ item }">
                  <span v-if="item.target_urgent && !item.target_date">
                    至急
                  </span>
                  <span v-else>
                    {{ item.target_date | date_format }}
                  </span>
                </template>
                <!-- /回収・積替・搬入日 -->

                <!-- 取引先(事業者)/取引先(事業場) -->
                <template v-slot:[`item.supplier`]="{ item }">
                  <div>
                    <small class="line-clamp one-clamp">
                      {{ item.supplier.name }}
                      <v-tooltip top :open-on-hover="false">
                        <template #activator="{ on }">
                          <v-btn
                            icon
                            tile
                            small
                            retain-focus-on-click
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>mdi-map-marker-outline</v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <strong>{{ item.supplier.name }}</strong>
                          <br />
                          <small>{{ item.supplier.address }}</small>
                        </div>
                      </v-tooltip>
                    </small>
                  </div>
                  <div>
                    <small class="line-clamp one-clamp">
                      {{ item.supplier_location.name }}
                      <v-tooltip top :open-on-hover="false">
                        <template #activator="{ on }">
                          <v-btn
                            v-if="item.supplier_location.name"
                            icon
                            tile
                            small
                            retain-focus-on-click
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>mdi-map-marker-outline</v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <strong>{{ item.supplier_location.name }}</strong>
                          <br />
                          <small>{{ item.supplier_location.address }}</small>
                        </div>
                      </v-tooltip>
                    </small>
                  </div>
                </template>
                <!-- /取引先(事業者)/取引先(事業場) -->

                <!-- 運送先事業場 -->
                <template v-slot:[`item.destination_location`]="{ item }">
                  <div>
                    <span class="line-clamp one-clamp">{{
                      item.destination_location.name
                    }}</span>
                  </div>
                  <small>
                    <span v-if="item.total_traders_count > 0">
                      &emsp;全&nbsp;{{ item.total_traders_count }}件
                    </span>
                  </small>
                </template>
                <!-- /運送先事業場 -->

                <!-- 取扱品目/荷姿 -->
                <template v-slot:[`item.item`]="{ item }">
                  <div v-if="item.item_name">
                    <v-chip
                      :title="item.item_name"
                      color="#F0E6D0"
                      label
                      x-small
                    >
                      {{ item.item_name | truncate(10) }}
                    </v-chip>
                  </div>
                  <small>
                    {{ item.packing_name }}
                    <span v-if="item.total_items_count > 0">
                      &emsp;全&nbsp;{{ item.total_items_count }}件
                    </span>
                  </small>
                </template>
                <!-- /取扱品目/荷姿 -->

                <!-- マニフェスト -->
                <template v-slot:[`item.manifest`]="{ item }">
                  <small>
                    {{ item.manifest_number }}
                    <span v-if="item.total_manifests_count > 0">
                      &emsp;全&nbsp;{{ item.total_manifests_count }}件
                    </span>
                  </small>
                </template>
                <!-- /マニフェスト -->
              </v-data-table>
            </v-col>
          </v-row>
          <!-- /ドライバー受注紐付け一覧 -->

          <!-- ページング -->
          <v-row>
            <v-col>
              <custom-pagination
                :page-number="page"
                :per-page="perPage"
                :pagination="pagination"
                :total-visible="totalVisible"
                @pageChanged="pageChangeEvent"
                @perPageChanged="perPageChangeCallback"
              />
            </v-col>
          </v-row>
          <!-- /ページング -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent"> 閉じる </v-btn>
          <v-btn
            :disabled="checkedResults.length <= 0"
            color="primary"
            @click="registerButtonClickEvent"
          >
            ドライバーに紐付け&nbsp;<v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style></style>
